export default __webpack_public_path__ + "static/media/sent.1056a342.svg";